import Vue from 'vue'
import memberConstant from '@/modules/member/config/memberConstant.js'
export default {
  onAppLaunch(vm) {
    this.vm = vm
    this.vm.$helper.getEnduringToken = () => this.getEnduringToken()
    this.vm.$helper.memberSetLoginToken = async (token, keepLogin, isDebugMode = false) => {
      if(isDebugMode) this.vm.$snotify.warning(null, '開始設定token')
      this.vm.$store.dispatch('token/setScope', window.scopeRules.roles.member)
      this.vm.$store.dispatch('token/set', token)
      if(isDebugMode) this.vm.$snotify.warning(null, 'before getToken callback')
      this.vm.$helper.getAppCallback('getToken')(token)
      if(isDebugMode) this.vm.$snotify.warning(null, 'after getToken callback')
      if(isDebugMode) this.vm.$snotify.warning(null, 'token設定完成')
      await this.vm.$nextTick()
      if(isDebugMode) this.vm.$snotify.warning(null, '$nextTick完成')
      const tokenData = this.vm.$store.getters['token/data']
      if(isDebugMode) this.vm.$snotify.warning(tokenData, 'Token Data')
      const name = !tokenData.name ? tokenData.email : tokenData.name
      this.vm.$snotify.success(
        this.vm.i18n('login.welcome', { name }),
        this.vm.i18n('login.success'),
      )
      this.vm.$helper.afterLoginSuccess(vm, 'member')
      this.vm.$nextTick()

      if(keepLogin === true) {
        await this.getEnduringToken()
      }

      this.vm.$helper.getAppCallback('loginSuccessfully')()
    }
    Vue.prototype.$MEMBER_CONSTANTS = memberConstant
    Vue.prototype.$customerServiceStatusList = [
      memberConstant.CUSTOMER_SERVICE_STATUS_PENDING,
      memberConstant.CUSTOMER_SERVICE_STATUS_PROCESSING,
      memberConstant.CUSTOMER_SERVICE_STATUS_PROCESSED,
    ]

    Vue.prototype.$visitStatusList = [
      memberConstant.VISIT_STATUS_PENDING,
      memberConstant.VISIT_STATUS_APPLY,
      memberConstant.VISIT_STATUS_REJECT,
    ]

    Vue.prototype.$pushType = [
      memberConstant.PUSH_TYPE_NOW,
      memberConstant.PUSH_TYPE_JOB,
      memberConstant.PUSH_TYPE_DRAFT,
    ]

    Vue.prototype.$visitGroupTypeList = [
      memberConstant.VISIT_GROUP_TYPE_幼兒,
      memberConstant.VISIT_GROUP_TYPE_安親班,
      memberConstant.VISIT_GROUP_TYPE_國小,
      memberConstant.VISIT_GROUP_TYPE_國中,
      memberConstant.VISIT_GROUP_TYPE_高中,
      memberConstant.VISIT_GROUP_TYPE_大專院校,
      memberConstant.VISIT_GROUP_TYPE_社會團體,
      memberConstant.VISIT_GROUP_TYPE_營隊,
      memberConstant.VISIT_GROUP_TYPE_其他,
    ]

    Vue.prototype.$representationStatusList = [
      memberConstant.REPRESENTATION_STATUS_PENDING,
      memberConstant.REPRESENTATION_STATUS_PROCESSING,
    ]

    Vue.prototype.$customerServiceTypes = [
      memberConstant.CUSTOMER_SERVICE_TYPE_NORMAL,
      memberConstant.CUSTOMER_SERVICE_TYPE_SATELLITE,
      memberConstant.CUSTOMER_SERVICE_TYPE_NETWORK,
      memberConstant.CUSTOMER_SERVICE_TYPE_PROGRAM,
    ]

    Vue.prototype.$customerServiceProblemTypes = [
      memberConstant.CUSTOMER_PROBLEM_TYPE_ASK,
      memberConstant.CUSTOMER_PROBLEM_TYPE_SUPPORT,
      memberConstant.CUSTOMER_PROBLEM_TYPE_PRAISE,
      memberConstant.CUSTOMER_PROBLEM_TYPE_COMPLAIN,
      memberConstant.CUSTOMER_PROBLEM_TYPE_CRITICISM,
      memberConstant.CUSTOMER_PROBLEM_TYPE_RECOMMEND,
    ]

    // 客服紀錄問題所屬單位
    Vue.prototype.$customerServiceDepartment = [
      memberConstant.CUSTOMER_SERVICE_DEPARTMENT_PROJECT,
      memberConstant.CUSTOMER_SERVICE_DEPARTMENT_ADMIN,
      memberConstant.CUSTOMER_SERVICE_DEPARTMENT_PROGRAM,
      memberConstant.CUSTOMER_SERVICE_DEPARTMENT_NEWS,
      memberConstant.CUSTOMER_SERVICE_DEPARTMENT_MARKETING,
    ]

    // 客服紀錄服務項目
    Vue.prototype.$customerServiceItem = [
      memberConstant.CUSTOMER_SERVICE_ITEM_PROGRAM,
      memberConstant.CUSTOMER_SERVICE_ITEM_SCHEDULE,
      memberConstant.CUSTOMER_SERVICE_ITEM_NETWORK,
      memberConstant.CUSTOMER_SERVICE_ITEM_MARKETING,
      memberConstant.CUSTOMER_SERVICE_ITEM_DUBBING,
      memberConstant.CUSTOMER_SERVICE_ITEM_WATCH,
      memberConstant.CUSTOMER_SERVICE_ITEM_OTHER,
    ]

    // 客服紀錄意見來源
    Vue.prototype.$customerServiceSource = [
      memberConstant.CUSTOMER_PROBLEM_SOURCE_CUSTOM,
      memberConstant.CUSTOMER_PROBLEM_SOURCE_POST,
      memberConstant.CUSTOMER_PROBLEM_SOURCE_FAX,
      memberConstant.CUSTOMER_PROBLEM_SOURCE_ONLINE,
      memberConstant.CUSTOMER_PROBLEM_SOURCE_EMAIL,
      memberConstant.CUSTOMER_PROBLEM_SOURCE_GROUP,
      memberConstant.CUSTOMER_PROBLEM_SOURCE_SITE,
    ]

    // 客服紀錄回覆時間
    Vue.prototype.$customerServiceReplyTime = [
      memberConstant.CUSTOMER_PROBLEM_REPLY_TIME_SITE,
      memberConstant.CUSTOMER_PROBLEM_REPLY_TIME_LESS_ONE,
      memberConstant.CUSTOMER_PROBLEM_REPLY_TIME_ONE,
      memberConstant.CUSTOMER_PROBLEM_REPLY_TIME_TWO,
      memberConstant.CUSTOMER_PROBLEM_REPLY_TIME_THREE,
      memberConstant.CUSTOMER_PROBLEM_REPLY_TIME_OVER_THREE,
    ]


    Vue.prototype.$memberLoginConfirm = () => {
      this.vm.$apopup.base({
        title: this.vm.i18n('member.confirm.login-first'),
        content: this.vm.i18n('member.confirm.login-first.content'),
        applyCallback: () => {
          this.vm.$router.push({
            name: 'member.login',
            query: { path: this.vm.$route.fullPath }
          })
        },
      })
    }

    Vue.prototype.$customerServiceFaqSelector = ({ applyCallback, closeCallback = null, usedList = [], max }) => {
      vm.$targetSelector.active(vm, {
        title: '客服FAQ',
        bodySlot: () => import('modules/member/selector/customerServiceFaq.vue'),
        max: max === undefined ? 1 : max,
        applyCallback,
        closeCallback,
        usedList,
      })
    }

    Vue.prototype.$whichMegType = (type) => {
      if(type === memberConstant.NOTICE_TYPE_PUSH) return memberConstant.NOTICE_TYPE_PUSH
      if ([memberConstant.NOTICE_TYPE_ORDER_PROCESSING, memberConstant.NOTICE_TYPE_ORDER_PROCESSED].includes(type)) {
        return memberConstant.NOTICE_TYPE_ORDER
      }
      if ([memberConstant.NOTICE_TYPE_CUSTOMER_PROCESSING, memberConstant.NOTICE_TYPE_CUSTOMER_PROCESSED, memberConstant.NOTICE_TYPE_CUSTOMER_PENDING].includes(type)) {
        return memberConstant.NOTICE_TYPE_CUSTOMER
      }
      if ([memberConstant.NOTICE_TYPE_REPRESENTATION_PROCESSED].includes(type)) {
        return memberConstant.NOTICE_TYPE_REPRESENTATION
      }
      if ([memberConstant.NOTICE_TYPE_VISIT_APPLY, memberConstant.NOTICE_TYPE_VISIT_REJECT].includes(type)) {
        return memberConstant.NOTICE_TYPE_VISIT
      }
      return ''
    }
  },
  async getEnduringToken() {
    const enduringTokenScope = this.vm.$store.getters['token/enduringTokenScope']
    try {
      const result = await this.vm.$api.member.public.createEnduringToken()
      this.vm.$localStorage.set(enduringTokenScope, result.token)
      this.vm.$helper.getAppCallback('getEnduringToken')(result.token)
    } catch (error) {
      console.error(error)
    }
  },
}